import React, { useEffect, useState, useRef } from 'react';
import { Nav } from 'react-bootstrap';
import { ChangePassword, InvalidTokenModal, DecideWindow, LicenseExpire } from './common/modal_common.js';
import { getCookie, setCookie, deleteCookie, useInterval, getDecryptCookie, getPemission } from './common/app_common.js';
import { BsPerson, BsPower, BsGraphUp, BsFileText, BsSliders2, BsHddNetwork, BsBroadcastPin, BsBarChartSteps, BsDiagram3Fill,
    BsChevronLeft, BsColumnsGap, BsGrid3X3Gap, BsGearWide, BsPeople, BsLock, BsInfoLg, BsExclamationTriangle, BsShareFill,
    BsFileEarmarkText, BsGear} from 'react-icons/bs';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import PageLogin from './login';
import PageDashBoard from './pages/dash_board';
import PageDashBoardSingle from './pages/dash_board_single';
import PageSitesList from './pages/sites_list';
import PageCapacity from './pages/capacity.js';
import PageCoverage from './pages/coverage.js';
import PageAnalytics from './pages/analytics';
import PageLogs from './pages/logs';
import PageAlertStatus from './pages/alert_status.js';
import PageControlAlert from './pages/control_alert';
import PageControlSiteManager from './pages/control_site_manager';
import PageControlCoverageEdgeManager from './pages/control_coverage_edge_manager.js';
import PageControlSystem from './pages/control_system';
import PageControlUsers from './pages/control_users';
import PageControlToken from './pages/control_token';
import PageControlInfo from './pages/control_info';
import PageHostStatus from './pages/host_status.js';
import {PageDocumentNapi} from './pages/documentNapi.js';
import PageTest from './pages/test';
import { ToastContainer } from 'react-toastify';
import { postApiUserSignout, postApiToken, getApiSystemLicense } from './common/fetch_api/api_common';
import { getApiConfigSystem } from './common/fetch_api/configuration'
import 'react-toastify/dist/ReactToastify.css';
import { getApiAlertStatusCount } from './common/fetch_api/alert.js';

const SINGLE_VER = false;
const TEST_PAGE = false;

const addNavLink = (split, name, icon, title) => {
  return (
    <li className={`${split[1] === name ? "active" : ""}`}>
        <NavLink to={`/${name}`}>{icon} {title}</NavLink>
    </li>
  )
}

export const MainMenuBar = ({hide, split}) =>
{
    const [update, setUpdate] = useState(false);
    const pemission = useRef(0);

    useEffect( () => {
        pemission.current = getPemission();
    }, []);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        getAlertStatusCount();
    }, [update]);

    const [alertFiring, setAlertFiring] = useState(0);

    const getAlertStatusCount = () =>
    {
        Promise.resolve( getApiAlertStatusCount('') )
        .then( data =>
        {
            if(data.hasOwnProperty('count'))
            {
                if( data.count !== alertFiring )
                {
                    setAlertFiring(data.count);
                }
            }
            else
            {
                setAlertFiring(0);
            }
        });
    };

    useInterval(() =>
    {
        runUpdate();
    }, 10000 );

    return (
        <ul className={`list-unstyled position-static ${hide?'d-none':''}`}>
            {addNavLink(split, "", <BsColumnsGap size="16"/>, 'Dashboard')}
            {!SINGLE_VER && addNavLink(split, 'sites_list', <BsDiagram3Fill size="16"/>, 'Sites List')}
            {!SINGLE_VER && addNavLink(split, 'capacity', <BsBarChartSteps size="16"/>, 'Capacity')}
            {/* {!SINGLE_VER && addNavLink(split, 'coverage', <BsBroadcastPin size="16"/>, 'Coverage')} */}
            {!SINGLE_VER && 
                <li>
                    <NavLink style={{ color: 'gray', cursor: 'not-allowed' }}><BsBroadcastPin size="16"/> Coverage</NavLink>
                </li>
            }
            {!SINGLE_VER && addNavLink(split, 'analytics', <BsGraphUp size="16"/>, 'Analytics')}
            {/* {addNavLink(split, 'search', <BsSearch size="16"/>, 'Search')} */}
            {addNavLink(split, 'logs', <BsFileText size="16"/>, 'Log')}
            {/* {addNavLink(split, 'alert_status', <BsExclamationTriangle size="16"/>, 'Alert')} */}
            <li className={`${split[1] === 'alert_status' ? "active" : ""} position-relative`}>
                <NavLink to={`/alert_status`}><BsExclamationTriangle size="16"/> {'Alert'}<div className={`${alertFiring > 0 ? 'alert-dot' : ''}`}></div></NavLink>
            </li>
            { pemission.current > 0 &&
                <li>
                    <NavLink to='/control_alert'><BsSliders2/> Control Panel</NavLink>              
                </li>
            }
            {addNavLink(split, 'host_status', <BsHddNetwork size="16"/>, 'Host Status')}
            {TEST_PAGE && addNavLink(split, 'test', <></>, 'test')}
        </ul>
    );
}

export const SubMenuBar = ({hide, split}) => {
    const pemission = useRef(0);

    useEffect( () => {
        pemission.current = getPemission();
    }, []);

    return (
        <ul className={`list-unstyled position-static ${hide?'d-none':''}`}>
            {addNavLink(split, "control_alert", <BsExclamationTriangle size="16"/>, 'Alert')}
            {/* {addNavLink(split, "control_license", <BsCreditCard2Front size="16"/>, 'License')} */}
            {/* {addNavLink(split, "control_log_report", <BsLayoutTextWindowReverse size="16"/>, 'Log')} */}
            {/* {addNavLink(split, "control_network_connections", <BsDiagram2 size="16"/>, 'Network Connections')} */}
            {!SINGLE_VER && addNavLink(split, "control_site_manager", <BsGrid3X3Gap size="16"/>, 'Site Manager')}
            {/* {!SINGLE_VER && addNavLink(split, "control_coverage_edge_manager", <BsShareFill size="16"/>, 'Coverage Edge Manager')} */}
            {!SINGLE_VER && 
                <li>
                    <NavLink style={{ color: 'gray', cursor: 'not-allowed' }}><BsShareFill size="16"/> Coverage Edge Manager</NavLink>
                </li>
            }
            {addNavLink(split, "control_system", <BsGearWide size="16"/>, 'System')}
            {/* {addNavLink(split, "control_time", <BsClock size="16"/>, 'Time')} */}
            {!SINGLE_VER && pemission.current>1 && addNavLink(split, "control_users", <BsPeople size="16"/>, 'Users')}
            {addNavLink(split, "control_token", <BsLock size="16"/>, 'Token')}
            {addNavLink(split, "control_info", <BsInfoLg size="16"/>, 'Info')}
        </ul>
    );
}

const CustomNav = ({setLogin, changePw, checkLicense}) => {

    const [mainMenu, setMainMenu] = useState(true);
    const [systemName, setSystemName] = useState('');

    // useEffect(() => {
    // if( splitLocation[1].indexOf('control_') !== -1)
    // {
    //     setMainMenu(false);
    // }    
    // }, []);

    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");

    useEffect(() => {
        const isSub = pathname.includes('control_');
        setMainMenu(!isSub);
    }, [pathname]);

    useEffect(() => {
        Promise.resolve( getApiConfigSystem() )
        .then( systemInfo => {
            if( systemInfo && systemInfo.systemName !== undefined )
            {
                setSystemName(systemInfo.systemName);
            }
        });

        if( !mainMenu )
        {
            checkLicense();
        }

    },[mainMenu]);

    //site list 메뉴 외에 들어가면, siteInfo, edgeInfo 등 관련 세션데이터를 지움
    useEffect(() => {
        if( splitLocation[1] !== 'sites_list')
        {
            sessionStorage.removeItem('pageName');
            sessionStorage.removeItem('siteInfo');
            sessionStorage.removeItem('edgeInfo');
            sessionStorage.removeItem('term');
            sessionStorage.removeItem('refresh');
        }
    }, [splitLocation]);

    const onClickLogout = () => {
        let urlencoded = new URLSearchParams();
        urlencoded.append("username", getDecryptCookie('using'));

        Promise.resolve( postApiUserSignout(urlencoded) )
        .then( done =>
        {
            deleteCookie('accessToken');
            deleteCookie('accessTokenExp');
            deleteCookie('refreshToken');
            deleteCookie('refreshTokenExp');
            deleteCookie('type');
            deleteCookie('using');
            deleteCookie('term');
            deleteCookie('refresh');
            deleteCookie('accessTokenIntvID');
            // deleteCookie('tokenStatus');
            
            setLogin();
        });
    }

    return (
        <div id="sidebar" className={`side-bar ${mainMenu?'':'control-panel'}`}>
        {mainMenu
        ?
            <>
                <div className="menu-title">OnAir MapX</div>
                <div className="system-name">{systemName}</div>
            </>
        :
            <div className="goto-menu">
                <NavLink to='/'><BsChevronLeft size="16"/> Control Panel</NavLink>
            </div>
        }
            <div className="sidebar-nav scrollable" tabIndex="-1">
                <Nav className="nav-main">
                        <MainMenuBar hide={!mainMenu} split={splitLocation}></MainMenuBar>
                        <SubMenuBar hide={mainMenu} split={splitLocation}></SubMenuBar>
                </Nav>
                <Nav className={`nav-user ${!mainMenu?'d-none':''}`}>
                    <ul className="list-unstyled sticky-bottom position-static">
                        {addNavLink(splitLocation, 'document', <BsFileEarmarkText size="16"/>, 'Document')}
                        {addNavLink(splitLocation, 'openapi', <BsGear size="16"/>, 'OpenAPI 3.0')}
                        <li onClick={changePw}>
                            <NavLink><BsPerson size="16"/> User Setting</NavLink>
                        </li>
                        <li onClick={onClickLogout}>
                            <NavLink to='/'><BsPower size="16"/> Sign out</NavLink>
                        </li>
                    </ul>
                </Nav>
            </div>
        </div>
    )
}

const CustomRoute = () => {
    return (
        <div className='content'>
            <div className="container-fluid">
                <Routes>
                    <Route path='/' element={SINGLE_VER?<PageDashBoardSingle/>:<PageDashBoard />}></Route>
                    <Route path='/sites_list' element={<PageSitesList />}></Route>
                    <Route path='/capacity' element={<PageCapacity />}></Route>
                    <Route path='/coverage' element={<PageCoverage />}></Route>
                    <Route path='/analytics' element={<PageAnalytics />}></Route>
                    <Route path='/logs' element={<PageLogs />}></Route>
                    <Route path='/alert_status' element={<PageAlertStatus />}></Route>
                    <Route path='/control_alert' element={<PageControlAlert />}></Route>
                    <Route path='/control_site_manager' element={<PageControlSiteManager />}></Route>
                    <Route path='/control_coverage_edge_manager' element={<PageControlCoverageEdgeManager />}></Route>
                    <Route path='/control_system' element={<PageControlSystem />}></Route>
                    <Route path='/control_users' element={<PageControlUsers />}></Route>
                    <Route path='/control_token' element={<PageControlToken />}></Route>
                    <Route path='/control_info' element={<PageControlInfo />}></Route>
                    <Route path='/host_status' element={<PageHostStatus />}></Route>
                    <Route path='/document' element={<PageDocumentNapi title={'Document'} url={'/docs/document'} />}></Route>
                    <Route path='/openapi' element={<PageDocumentNapi title={'OpenAPI 3.0'} url={'/docs/api'} />}></Route>
                    <Route path='/test' element={<PageTest />}></Route>
                </Routes>
            </div>
        </div>
    )
}

export default function App()
{
    const [update, setUpdate] = useState(false);
    const [authStatus, setAuthStatus] = useState(0);

    const [modalChangePw, setModalChangePw] = useState(false);
    const closeModalChangePw = () => setModalChangePw(false);
    const showModalChangePw = () =>
    {
        setModalChangePw(true);
    };

    useEffect(() => {
        sessionStorage.removeItem('severCheckId');
    },[]);

    useEffect(() => {
        if(authStatus===0)
        {
            getAccessToken();
        }
    },[update]);

    function authorization()
    {
        setAuthStatus(2);
        runUpdate();
        
        checkLicense();
    }

    function deAuthorization()
    {
        setAuthStatus(0);
        runUpdate();
    }

    function runUpdate()
    {
        setUpdate(!update);
    }

    useInterval(() => {
        checkTokenExp();
    }, 5000 );

    function checkTokenExp()
    {
        //cookie value null check
        // if( checkCookieNull() )
        // {
        //   console.log('checkCookieNull');
        //   setAuthStatus(0);
        //   return;
        // }

        let accessTokenExp = getCookie("accessTokenExp");
        let accessTokenTime = 0;

        if( accessTokenExp !== 'NaN' )
        {
            accessTokenTime = parseInt( accessTokenExp );
        }    

        let date = new Date();
        let expTime = date.setTime(date.getTime());
        let accessRemainTime = accessTokenTime*1 - expTime;
        // let tokenStatus = getCookie('tokenStatus');

        if(accessRemainTime <= 0)
        {
            let refreshTokenTime = parseInt( getCookie("refreshTokenExp") );
            let refreshRemainTime = refreshTokenTime*1 - expTime;

            if(refreshRemainTime <= 0)
            {
                if( authStatus === 2)
                {
                    showInvalidModal();
                }
            }
            else
            {
                setTimeout(() => {
                    getAccessToken();
                }, 500);
            }
        }
        // if(accessRemainTime <= 120000 && tokenStatus == 'false')
        else if(accessRemainTime <= 120000)
        {
            // setCookie('tokenStatus', 'true');
            
            setTimeout(() => {
                getAccessToken();
            }, 500);
        }
    }

    function getAccessToken()
    {
        Promise.resolve( postApiToken() )
        .then(data => {
            if(data[1].status === 200)
            {
                let accessTokenExpMinute = data[0].accessTokenExpMinute;
                let accessTokenExp = 1000*60*accessTokenExpMinute;
                let accessToken = data[0].accessToken;
                
                setCookie('accessToken', accessToken);

                let date = new Date();
                let expDate = String(date.setTime(date.getTime() + accessTokenExp));
                
                setCookie('accessTokenExp', expDate);

                setTimeout(() => {
                    // setCookie('tokenStatus', 'false');
                    setAuthStatus(2);
                }, 100);
            }
            else
            {
                setAuthStatus(1);
            }
        })
        .catch(err => {
            setAuthStatus(1);
        });
    }

    const [invalidMsg, setInvalidMsg] = useState('');
    const [invalidModal, setInvalidModal] = useState(false);
    const showInvalidModal = () => {
        setInvalidModal(true)
    };
    const closeInvalidModal = () => setInvalidModal(false);

    const onClickResButton = (e) => {
        let temp = JSON.parse(e.target.value);
        // console.log('onClickResButton', temp);

        if( temp.detail )
        {
            setInvalidMsg(temp.detail);
            setAuthStatus(1);
            showInvalidModal(true);
        }
    }

    const [decideBody, setDecideBody] = useState("");
    
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = () => setModalDecide(true);

    function checkLicense()
    {
        Promise.resolve( getApiSystemLicense() )
        .then( data => {
            const activated = !data.activated ? false : data.activated;
            const activationStatus = !data.activationStatus ? 'License file not found or invalid' : data.activationStatus;
            
            if( !activated )
            {
                setDecideBody(activationStatus);
                showModalDecide();
            }
        })
        .catch( e => {
            console.log('System License Info Error:', e);
        });
    }

    return (
        <>
            { authStatus===1 && <PageLogin setLogin={authorization}/> }
            { authStatus===2 &&
                <div className='wrapper'>
                    <CustomNav setLogin={deAuthorization} changePw={showModalChangePw} checkLicense={checkLicense}/>
                    <CustomRoute/>
                </div>
            }
            <ToastContainer/>
            {modalChangePw&&<ChangePassword username={getDecryptCookie('using')} show={modalChangePw} handleClose={closeModalChangePw} update={null}></ChangePassword>}
            {invalidModal&&<InvalidTokenModal msg={invalidMsg} show={invalidModal} handleClose={closeInvalidModal} ></InvalidTokenModal>}
            <div className='d-none'>
                <button id='resButton' onClick={onClickResButton}/>
            </div>
            {modalDecide&&<LicenseExpire show={modalDecide} handleClose={closeModalDecide} body={decideBody}></LicenseExpire>}
        </>
    );
}